import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ user, onLoginClick, onLogout }) => {
  const navigate = useNavigate();
  const showAboutModal = () => {
    alert('About Aminole modal - Coming soon!\n\nAminole is an interactive game that helps you learn amino acids through a Wordle-like experience.');
  };

  const showFeedbackModal = () => {
    // Open Google Form in new tab for feedback collection
    const googleFormUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfnV0YtjIqmYou9ib5b8mkbSNNqBsb_vIJni1DUdAT-tpylJw/viewform?usp=header';
    window.open(googleFormUrl, '_blank');
  };

  return (
    <header id="aminole-header" className="aminole-header">
      <div className="header-container">
        <div className="header-left">
          <img 
            src={`${process.env.PUBLIC_URL}/assets/images/ci_logo.png`} 
            alt="Aminole Logo" 
            className="header-logo" 
          />
        </div>

        <div className="header-right">
          <button 
            className="header-btn play-btn" 
            onClick={() => navigate('/')}
          >
            Play Aminole
          </button>

          <button 
            className="header-btn about-btn" 
            onClick={showAboutModal}
          >
            About Aminole
          </button>

          <button 
            className="header-btn feedback-btn" 
            onClick={showFeedbackModal}
          >
            Submit Feedback
          </button>

          {user ? (
            <div className="user-section">
              {/* Role-specific navigation */}
              {user.role === 'teacher' ? (
                <button 
                  className="header-btn class-btn" 
                  onClick={() => navigate('/teacher-dashboard')}
                >
                  My Class 👨‍🏫
                </button>
              ) : (
                <button 
                  className="header-btn join-class-btn" 
                  onClick={() => navigate('/join-class')}
                >
                  Join Class 🎓
                </button>
              )}
              
              <button 
                className="header-btn user-stats-btn" 
                onClick={() => navigate('/statistics')}
              >
                Account 📊
              </button>
              <button 
                className="header-btn logout-btn" 
                onClick={onLogout}
              >
                Logout
              </button>
            </div>
          ) : (
            <button 
              className="header-btn login-btn" 
              onClick={() => {
                onLoginClick();
                navigate('/auth');
              }}
            >
              Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
